import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../firebase';

/**
 * AnalyticsTracker component
 * Automatically captures route transitions and logs `page_view` events to Firebase Analytics.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    trackPageView(currentPath, document.title);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
